import React from "react";
import { TableCell, TableRow } from "../../../design/table";
import { Folder } from "../../../models/Folder";
import moment from "moment";
import { FolderIcon } from "@heroicons/react/20/solid";

interface Props {
  folder: Folder;
}

const FolderListItem: React.FC<Props> = ({ folder }) => {
  return (
    <TableRow
      key={folder._id}
      href={`/folder/${folder._id}`}
      className="transition-colors cursor-pointer hover:bg-gray-100"
    >
      <TableCell className="flex items-center gap-2">
        <FolderIcon className="w-5 h-5 text-gray-500" />
        {folder.name}
      </TableCell>
      <TableCell />
      <TableCell className="text-right">
        <span className="text-sm text-gray-500">
          {moment(folder.updatedAt).format("MMMM D, YYYY")}
        </span>
      </TableCell>
    </TableRow>
  );
};

export default FolderListItem;
